// UID: BWR-TAX_RTN_1Y-CHK
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2347
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  HasApplicantFiledTR,
  IsBetweenJanAndMidFeb,
  IsBetweenMidAprilMidMay,
  IsBetweenMidAugMidOct,
  IsBetweenMidMayMidAug,
  IsForProfit,
  RulesetResult,
} from '../rules';
import IsFBO from '../rules/IsFBO';
import IsBetweenMidFebMidApril from '../rules/IsBetweenMidFebMidApril';
import IsBusinessEstablishedLessThan from '../rules/IsBusinessEstablishedLessThan';

class ApplicantFiledTRLastYearRuleset implements Ruleset {
  public forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const isBetweenJanAndMidFeb = IsBetweenJanAndMidFeb.evaluate(data);
    const isBetweenMidFebMidApril = IsBetweenMidFebMidApril.evaluate(data);
    const isBetweenMidAprilMidMay = IsBetweenMidAprilMidMay.evaluate(data);
    const isBetweenMidMayMidAug = IsBetweenMidMayMidAug.evaluate(data);
    const isBetweenMidAugMidOct = IsBetweenMidAugMidOct.evaluate(data);
    const establishedLessThanTwoYearsAgo =
      IsBusinessEstablishedLessThan.setYears(2).evaluate(data);

    if (isBetweenJanAndMidFeb || isBetweenMidFebMidApril) {
      return RulesetResult.HIDDEN;
    } else if (
      isBetweenMidAprilMidMay ||
      isBetweenMidMayMidAug ||
      isBetweenMidAugMidOct
    ) {
      return RulesetResult.REQUIRED;
    }
    return establishedLessThanTwoYearsAgo
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (IsFBO.evaluate(data)) return RulesetResult.HIDDEN;
    const isForProfit = IsForProfit.evaluate(data);
    if (isForProfit) return this.forProfitResult(data);
    const hasApplicantEverFiledTR = HasApplicantFiledTR.evaluate(data);
    if (
      hasApplicantEverFiledTR &&
      [
        IsBetweenMidAprilMidMay,
        IsBetweenMidMayMidAug,
        IsBetweenMidAugMidOct,
      ].some((Is) => Is.evaluate(data))
    )
      return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}

export default new ApplicantFiledTRLastYearRuleset();
